import script from "./user-message.vue?vue&type=script&setup=true&lang=js"
export * from "./user-message.vue?vue&type=script&setup=true&lang=js"

import "./user-message.vue?vue&type=style&index=0&id=5ffe5a6f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ffe5a6f"]])

export default __exports__